export default {
    dashboard: 'ภาพรวมข้อมูล',
    inquiryAttendance: 'คำร้องและการปรับเวลา',
    employeeManagement: 'บริหารจัดการพนักงาน',
    pin: 'รหัส PIN',
    messageManagement: 'จัดการข้อความ',
    timableSettings: 'ตั้งค่าเวลาการทำงาน',
    report: 'รายงาน',
    visitor: 'ผู้เยี่ยมชม/ผู้มาติดต่อ',
    logOut: 'ลงชื่อออก',
    powerdBy: 'พัฒนาโดย โอคอนเทค'
}
